const getLinkBase = require('@bottlebooks/gatsby-theme-event/src/getLink');

/**
 * Returns the functions to create a link to a particular entity.
 * This is in CommonJS because it is also used from gatsby-node.
 * @param {LinkContext | undefined} context
 * @returns
 */
module.exports = function getLink(context) {
  const link = getLinkBase(context);
  return {
    ...link,
    producer: () => undefined,
    producers: () => undefined,
    room: (room) => {
      if (!room?.floor?.slug) return null;
      return `/exhibitors/${room.floor.slug}/${room.slug}`;
    },
    floor: (floor) => `/exhibitors/${floor.slug}`,
  };
};
